function truncateString(string, numberOfCharacters) {
  let stringToTruncate;
  if (typeof string === "string") stringToTruncate = string;
  else if (typeof string === "number") stringToTruncate = string.toString();
  else stringToTruncate = "";

  return stringToTruncate.length > numberOfCharacters
    ? stringToTruncate.slice(0, numberOfCharacters - 1) + "..."
    : stringToTruncate;
}

export default truncateString;
